/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=(t,n)=>!!n&&(t===n||e(t,n.parentElement));export{e as isNodeOrChild};
//# sourceMappingURL=is-node-or-child.js.map
